var path = 'public/app/core/components/navbar/navbar.html';
var html = "<div class=page-nav>\n  <div class=page-breadcrumbs>\n    <a class=\"breadcrumb-item active\" href=/ >\n      <i class=\"fa fa-home\"></i>\n    </a>\n    <a class=breadcrumb-item ng-href={{::item.url}} ng-repeat=\"item in ctrl.model.breadcrumbs\">\n      {{::item.text}}\n    </a>\n  </div>\n</div>\n\n<dashboard-search></dashboard-search>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/core/components/navbar/navbar.html
// module id = 1023
// module chunks = 3